<template>
  <div>

    <hr class="mb-0">

    <b-tabs>

      <!-- First tab -->
      <b-tab :title="$t('activities.risk_scenario.inherent_risk.inherent_risk_label')" active>
        <div class="row mt-4">
          <div class="col-sm-6" v-if="hasType('business_risk')">
            <h5>{{ $t('activities.risk_scenario.inherent_risk.business_risk') }}</h5>
            <hr class="mb-0"/>
              <div class="row no-gutters">
                <div class="col-sm-4 card-menu">
                  <div class="card-body text-dark" v-if="getClient.risk_type != 'cia_risk'">
                    <span>{{ $t('activities.risk_scenario.inherent_risk.inherent_risk_label') }}</span>
                  </div>

                  <div v-if="getClient.risk_type == 'cia_risk'">
                    <div class="card-body text-dark">
                      <span class="mt-2">{{ $t('processes.confidentiality.title') }}</span>
                    </div>
                    <div class="card-body text-dark">
                      <span class="mt-2">{{ $t('processes.integrity.title') }}</span>
                    </div>
                    <div class="card-body text-dark">
                      <span class="mt-2">{{ $t('processes.availability.title') }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-sm-8">
                  <div>
                    <div v-if="getClient.risk_type != 'cia_risk'">
                      <div v-if="riskScenarioItem && riskScenarioItem.business_inherent_risk" class="card-body">
                        <span :qid="'risk-risk-' + riskScenarioItem.business_inherent_risk.risk">
                          <font-awesome-icon
                            icon="exclamation-triangle"
                            v-if="riskScenarioItem.business_inherent_risk.number"
                            :class="[ riskScenarioItem.business_inherent_risk.number ? 'risk-'+riskScenarioItem.business_inherent_risk.number : 'risk' ]"
                          />
                          <span v-if="riskScenarioItem.business_inherent_risk.risk">
                            {{ $t('risk.' + $options.filters.slugify(riskScenarioItem.business_inherent_risk.risk)) }}
                          </span>
                          <span v-if="riskScenarioItem.business_inherent_risk.number">
                            ({{riskScenarioItem.business_inherent_risk.number}})
                          </span>
                          &nbsp;
                        </span>
                      </div>
                    </div>
                    <div v-if="getClient.risk_type == 'cia_risk'">

                      <!-- Confidentiality -->
                      <div v-if="riskScenarioItem && riskScenarioItem.business_confidentiality_inherent_risk" class="card-body">
                        <span :qid="'risk-risk-' + riskScenarioItem.business_confidentiality_inherent_risk.risk">
                          <font-awesome-icon
                            icon="exclamation-triangle"
                            v-if="riskScenarioItem.business_confidentiality_inherent_risk.number"
                            :class="[ riskScenarioItem.business_confidentiality_inherent_risk.number ? 'risk-'+riskScenarioItem.business_confidentiality_inherent_risk.number : 'risk' ]"
                          />
                          <span v-if="riskScenarioItem.business_confidentiality_inherent_risk.risk">
                            {{ $t('risk.' + $options.filters.slugify(riskScenarioItem.business_confidentiality_inherent_risk.risk)) }}
                          </span>
                          <span v-if="riskScenarioItem.business_confidentiality_inherent_risk.number">
                            ({{riskScenarioItem.business_confidentiality_inherent_risk.number}})
                          </span>
                          &nbsp;
                        </span>
                      </div>

                      <!-- Integrity -->
                      <div v-if="riskScenarioItem && riskScenarioItem.business_integrity_inherent_risk" class="card-body">
                        <span :qid="'risk-risk-' + riskScenarioItem.business_integrity_inherent_risk.risk">
                          <font-awesome-icon
                            icon="exclamation-triangle"
                            v-if="riskScenarioItem.business_integrity_inherent_risk.number"
                            :class="[ riskScenarioItem.business_integrity_inherent_risk.number ? 'risk-'+riskScenarioItem.business_integrity_inherent_risk.number : 'risk' ]"
                          />
                          <span v-if="riskScenarioItem.business_integrity_inherent_risk.risk">
                            {{ $t('risk.' + $options.filters.slugify(riskScenarioItem.business_integrity_inherent_risk.risk)) }}
                          </span>
                          <span v-if="riskScenarioItem.business_integrity_inherent_risk.number">
                            ({{riskScenarioItem.business_integrity_inherent_risk.number}})
                          </span>
                          &nbsp;
                        </span>
                      </div>

                      <!-- Availability -->
                      <div v-if="riskScenarioItem && riskScenarioItem.business_availability_inherent_risk" class="card-body">
                        <span :qid="'risk-risk-' + riskScenarioItem.business_availability_inherent_risk.risk">
                          <font-awesome-icon
                            icon="exclamation-triangle"
                            v-if="riskScenarioItem.business_availability_inherent_risk.number"
                            :class="[ riskScenarioItem.business_availability_inherent_risk.number ? 'risk-'+riskScenarioItem.business_availability_inherent_risk.number : 'risk' ]"
                          />
                          <span v-if="riskScenarioItem.business_availability_inherent_risk.risk">
                            {{ $t('risk.' + $options.filters.slugify(riskScenarioItem.business_availability_inherent_risk.risk)) }}
                          </span>
                          <span v-if="riskScenarioItem.business_availability_inherent_risk.number">
                            ({{riskScenarioItem.business_availability_inherent_risk.number}})
                          </span>
                          &nbsp;
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div class="row no-gutters">
                <div class="col-sm-4 card-menu">
                  <div class="card-body text-dark">
                    <span>{{ $t('activities.risk_scenario.inherent_risk.description_label') }}</span>
                  </div>
                </div>
                <div class="col-sm-8">
                  <div class="card-body">
                    <div>
                      <div v-if="riskScenarioItem.business_description">
                        <div v-if="riskScenarioItem.business_description && riskScenarioItem.business_description.length > descriptionLength">
                          <p v-if="showBusinessDescription" class="text-formatted">
                            {{ riskScenarioItem.business_description }}
                          </p>
                          <p v-if="!showBusinessDescription" class="text-formatted">
                            {{ riskScenarioItem.business_description | truncate(descriptionLength) }}
                          </p>
                          <div class="text-center mt-3" @click="showBusinessDescription=!showBusinessDescription">
                            <span class="cursor-pointer" v-if="!showBusinessDescription">
                              <span class="mr-2">
                                {{ $t('system.view_more') }}
                              </span>
                              <font-awesome-icon icon="chevron-down"/>
                            </span>
                            <span class="cursor-pointer" v-if="showBusinessDescription">
                              <span class="mr-2">
                                {{ $t('system.view_less') }}
                              </span>
                              <font-awesome-icon icon="chevron-up"/>
                            </span>
                          </div>
                        </div>
                        <p v-if="riskScenarioItem.business_description && riskScenarioItem.business_description.length <= descriptionLength" class="text-formatted">
                          {{ riskScenarioItem.business_description }}
                        </p>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row no-gutters">
                <div class="col-sm-4 card-menu">
                  <div class="card-body text-dark">
                    <span>{{ $t('activities.risk_scenario.inherent_risk.financial_impact_label') }}</span>
                  </div>
                </div>
                <div class="col-sm-8">
                  <div class="card-body">
                    <div>
                      <div v-if="riskScenarioItem && riskScenarioItem.business_amount">
                        <p qid="risk-dpia">
                          {{ getBusinessAmount }} {{ riskScenarioItem.business_currency }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row no-gutters">
                <div class="col-sm-4 card-menu">
                  <div class="card-body text-dark">
                    <span>{{ $t('activities.risk_scenario.inherent_risk.impact_effects_label') }}</span>
                  </div>
                </div>
                <div class="col-sm-8">
                  <div class="card-body">
                    <div>
                      <div v-if="riskScenarioItem && riskScenarioItem.business_impact_effects">
                        <span class="mr-1" v-for="effect in riskScenarioItem.business_impact_effects" qid="p-tags-list">
                          <span class="badge badge-info mb-1" :title="effect.name">
                            {{ effect.name | truncate(35) }}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Privacy risk -->

            <div class="col-sm-6" v-if="hasType('privacy_risk')">
              <h5>{{ $t('activities.risk_scenario.inherent_risk.privacy_risk') }}</h5>
              <hr class="mb-0"/>
              <div class="row no-gutters">
                <div class="col-sm-4 card-menu">
                  <div class="card-body text-dark" v-if="getClient.risk_type != 'cia_risk'">
                    <span>{{ $t('activities.risk_scenario.inherent_risk.inherent_risk_label') }}</span>
                  </div>

                  <div v-if="getClient.risk_type == 'cia_risk'">
                    <div class="card-body text-dark">
                      <span class="mt-2">{{ $t('processes.confidentiality.title') }}</span>
                    </div>
                    <div class="card-body text-dark">
                      <span class="mt-2">{{ $t('processes.integrity.title') }}</span>
                    </div>
                    <div class="card-body text-dark">
                      <span class="mt-2">{{ $t('processes.availability.title') }}</span>
                    </div>
                  </div>

                </div>
                <div class="col-sm-8">
                  <div>
                    <div v-if="getClient.risk_type != 'cia_risk'">
                      <div v-if="riskScenarioItem && riskScenarioItem.privacy_inherent_risk" class="card-body">
                        <span :qid="'risk-risk-' + riskScenarioItem.privacy_inherent_risk.risk">
                          <font-awesome-icon
                                  icon="exclamation-triangle"
                                  v-if="riskScenarioItem.privacy_inherent_risk.number"
                                  :class="[ riskScenarioItem.privacy_inherent_risk.number ? 'risk-'+riskScenarioItem.privacy_inherent_risk.number : 'risk' ]"
                          />
                          <span v-if="riskScenarioItem.privacy_inherent_risk.risk">
                            {{ $t('risk.' + $options.filters.slugify(riskScenarioItem.privacy_inherent_risk.risk)) }}
                          </span>
                          <span v-if="riskScenarioItem.privacy_inherent_risk.number">
                            ({{riskScenarioItem.privacy_inherent_risk.number}})
                          </span>
                          &nbsp;
                        </span>
                      </div>
                    </div>
                    <div v-if="getClient.risk_type == 'cia_risk'">

                      <!-- Confidentiality -->
                      <div v-if="riskScenarioItem && riskScenarioItem.privacy_confidentiality_inherent_risk" class="card-body">
                        <span :qid="'risk-risk-' + riskScenarioItem.privacy_confidentiality_inherent_risk.risk">
                          <font-awesome-icon
                            icon="exclamation-triangle"
                            v-if="riskScenarioItem.privacy_confidentiality_inherent_risk.number"
                            :class="[ riskScenarioItem.privacy_confidentiality_inherent_risk.number ? 'risk-'+riskScenarioItem.privacy_confidentiality_inherent_risk.number : 'risk' ]"
                          />
                          <span v-if="riskScenarioItem.privacy_confidentiality_inherent_risk.risk">
                            {{ $t('risk.' + $options.filters.slugify(riskScenarioItem.privacy_confidentiality_inherent_risk.risk)) }}
                          </span>
                          <span v-if="riskScenarioItem.privacy_confidentiality_inherent_risk.number">
                            ({{riskScenarioItem.privacy_confidentiality_inherent_risk.number}})
                          </span>
                          &nbsp;
                        </span>
                      </div>

                      <!-- Integrity -->
                      <div v-if="riskScenarioItem && riskScenarioItem.privacy_integrity_inherent_risk" class="card-body">
                        <span :qid="'risk-risk-' + riskScenarioItem.privacy_integrity_inherent_risk.risk">
                          <font-awesome-icon
                            icon="exclamation-triangle"
                            v-if="riskScenarioItem.privacy_integrity_inherent_risk.number"
                            :class="[ riskScenarioItem.privacy_integrity_inherent_risk.number ? 'risk-'+riskScenarioItem.privacy_integrity_inherent_risk.number : 'risk' ]"
                          />
                          <span v-if="riskScenarioItem.privacy_integrity_inherent_risk.risk">
                            {{ $t('risk.' + $options.filters.slugify(riskScenarioItem.privacy_integrity_inherent_risk.risk)) }}
                          </span>
                          <span v-if="riskScenarioItem.privacy_integrity_inherent_risk.number">
                            ({{riskScenarioItem.privacy_integrity_inherent_risk.number}})
                          </span>
                          &nbsp;
                        </span>
                      </div>

                      <!-- Availability -->
                      <div v-if="riskScenarioItem && riskScenarioItem.privacy_availability_inherent_risk" class="card-body">
                        <span :qid="'risk-risk-' + riskScenarioItem.privacy_availability_inherent_risk.risk">
                          <font-awesome-icon
                            icon="exclamation-triangle"
                            v-if="riskScenarioItem.privacy_availability_inherent_risk.number"
                            :class="[ riskScenarioItem.privacy_availability_inherent_risk.number ? 'risk-'+riskScenarioItem.privacy_availability_inherent_risk.number : 'risk' ]"
                          />
                          <span v-if="riskScenarioItem.privacy_availability_inherent_risk.risk">
                            {{ $t('risk.' + $options.filters.slugify(riskScenarioItem.privacy_availability_inherent_risk.risk)) }}
                          </span>
                          <span v-if="riskScenarioItem.privacy_availability_inherent_risk.number">
                            ({{riskScenarioItem.privacy_availability_inherent_risk.number}})
                          </span>
                          &nbsp;
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row no-gutters">
                <div class="col-sm-4 card-menu">
                  <div class="card-body text-dark">
                    <span>{{ $t('activities.risk_scenario.inherent_risk.description_label') }}</span>
                  </div>
                </div>
                <div class="col-sm-8">
                  <div class="card-body">
                    <div>

                      <div v-if="riskScenarioItem.privacy_description">
                        <div v-if="riskScenarioItem.privacy_description && riskScenarioItem.privacy_description.length > descriptionLength">
                          <p v-if="showPrivacyDescription" class="text-formatted">
                            {{ riskScenarioItem.privacy_description }}
                          </p>
                          <p v-if="!showPrivacyDescription" class="text-formatted">
                            {{ riskScenarioItem.privacy_description | truncate(descriptionLength) }}
                          </p>
                          <div class="text-center mt-3" @click="showPrivacyDescription=!showPrivacyDescription">
                          <span class="cursor-pointer" v-if="!showPrivacyDescription">
                            <span class="mr-2">
                              {{ $t('system.view_more') }}
                            </span>
                            <font-awesome-icon icon="chevron-down"/>
                          </span>
                            <span class="cursor-pointer" v-if="showPrivacyDescription">
                            <span class="mr-2">
                              {{ $t('system.view_less') }}
                            </span>
                            <font-awesome-icon icon="chevron-up"/>
                          </span>
                          </div>
                        </div>
                        <p v-if="riskScenarioItem.privacy_description && riskScenarioItem.privacy_description.length <= descriptionLength" class="text-formatted">
                          {{ riskScenarioItem.privacy_description }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row no-gutters">
                <div class="col-sm-4 card-menu">
                  <div class="card-body text-dark">
                    <span>{{ $t('activities.risk_scenario.inherent_risk.impact_effects_label') }}</span>
                  </div>
                </div>
                <div class="col-sm-8">
                  <div class="card-body">
                    <div>
                      <div v-if="riskScenarioItem && riskScenarioItem.privacy_impact_effects">
                  <span class="mr-1" v-for="effect in riskScenarioItem.privacy_impact_effects" qid="p-tags-list">
                    <span class="badge badge-info mb-1" :title="effect.name">
                      {{ effect.name | truncate(35) }}
                    </span>
                  </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row no-gutters">
                <div class="col-sm-4 card-menu">
                  <div class="card-body text-dark">
                    &nbsp;
                  </div>
                </div>
                <div class="col-sm-8">
                  <div class="card-body">
                    <div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </b-tab>
      <!-- First tab -->
      <b-tab :title="$t('activities.risk_scenario.mitigation_controls_label')">

        <div class="row mt-4">
          <div class="col-sm-12">
            <h6>{{ $t('activities.risk_scenario.generic_controls_label') }}</h6>
            <div class="form-control auto-height">
              <table class="table table-responsive-md table-sm">
                <thead>
                <tr>
                  <th scope="col">
                    {{ $t('activities.risk_scenario.current_risk.table.name') }}
                  </th>
                  <th scope="col">
                    {{ $t('system.last_performed') }}
                  </th>
                  <th scope="col" width="150">
                    {{ $t('system.latest_status') }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in genericControlsItems"
                    class="text-bold"
                >
                  <td>
                    {{ item.generic_control.name }}
                  </td>
                  <td>
                  <span v-if="item.last_performed">
                    <Avatar :object="item.last_performed.completed_by" size="xs" class="mr-2"></Avatar>
                    {{ item.last_performed.completed_at | formatDate }}
                  </span>
                  </td>
                  <td>
                    <span v-if="item.last_performed">
                      <ControlResultBadge v-if="['completed', 'deviations', 'not_performed', 'not_applicable', 'pass', 'fail'].includes(item.last_performed.completion_status)" :value="item.last_performed.completion_status"></ControlResultBadge>
                      <span v-else>
                        <font-awesome-icon
                                icon="exclamation-triangle"
                                class="risk-0"
                        />
                        {{ $t('system.not_performed')}}
                      </span>
                    </span>
                    <span v-else>
                      <font-awesome-icon
                              icon="exclamation-triangle"
                              class="risk-0"
                      />
                      {{ $t('system.not_performed')}}
                    </span>
                  </td>
                </tr>
                <tr v-if="genericControlsItems && !genericControlsItems.length" qid="no-results-row" class="text-center">
                  <td colspan="10">
                    <h5 class="mt-3">
                      {{ $t('system.no_results') }}
                    </h5>
                  </td>
                </tr>
                <tr v-if="genericControlsShowMore">
                  <td colspan="10">
                    <div class="text-center">
                      <span class="cursor-pointer" @click="loadGenericControls()">{{ $t('system.show_more') }}</span>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </b-tab>

      <!-- First tab -->
      <b-tab :title="$t('activities.risk_scenario.threats_label')">
        <div class="row mt-4">
        <div class="col-sm-12">
          <h6>{{ $t('activities.risk_scenario.threats_label') }}</h6>
          <div class="form-control auto-height mb-4">
            <table class="table table-responsive-md table-sm">
              <thead>
              <tr>
                <th scope="col">
                  {{ $t('activities.risk_scenario.current_risk.table.name') }}
                </th>
                <th scope="col">
                  {{ $t('maintenance.threats.table.actors') }}
                </th>
                <th scope="col" width="140">
                  {{ $t('system.status') }}
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in threatsItems"
                  class="text-bold"
              >
                <td>
                  {{ item.threat.name }}
                </td>
                <td>
                  <span class="mr-1" v-for="actor in item.threat.actors" qid="p-tags-list">
                    <span class="badge badge-info mb-1">
                      {{actor.name}}
                    </span>
                  </span>
                </td>
                <td>
                  <span v-if="item.last_performed">
                    <ControlResultBadge v-if="['completed', 'deviations', 'not_performed', 'not_applicable', 'pass', 'fail'].includes(item.last_performed.completion_status)" :value="item.last_performed.completion_status"></ControlResultBadge>
                    <span v-else>
                      <font-awesome-icon
                              icon="exclamation-triangle"
                              class="risk-0"
                      />
                      {{ $t('system.not_performed')}}
                    </span>
                  </span>
                  <span v-else>
                      <font-awesome-icon
                              icon="exclamation-triangle"
                              class="risk-0"
                      />
                      {{ $t('system.not_mitigated')}}
                    </span>
                </td>
              </tr>
              <tr v-if="threatsItems && !threatsItems.length" qid="no-results-row" class="text-center">
                <td colspan="10">
                  <h5 class="mt-3">
                    {{ $t('system.no_results') }}
                  </h5>
                </td>
              </tr>
              <tr v-if="threatsShowMore">
                <td colspan="10">
                  <div class="text-center">
                    <span class="cursor-pointer" @click="loadThreats()">{{ $t('system.show_more') }}</span>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        </div>
      </b-tab>

      <!-- First tab -->
      <b-tab :title="$t('activities.risk_scenario.vulnerabilities_label')">
        <div class="row mt-4">
        <div class="col-sm-12">
          <h6>{{ $t('activities.risk_scenario.vulnerabilities_label') }}</h6>
          <div class="form-control auto-height">
            <table class="table table-responsive-md table-sm">
              <thead>
              <tr>
                <th scope="col">
                  {{ $t('activities.risk_scenario.current_risk.table.name') }}
                </th>
                <th scope="col" width="140">
                  {{ $t('system.status') }}
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in vulnerabilitiesItems"
                  class="text-bold"
              >
                <td>
                  {{ item.vulnerability.name }}
                </td>
                <td>
                  <span v-if="item.last_performed">
                    <ControlResultBadge v-if="['completed', 'deviations', 'not_performed', 'not_applicable', 'pass', 'fail'].includes(item.last_performed.completion_status)" :value="item.last_performed.completion_status"></ControlResultBadge>
                    <span v-else>
                      <font-awesome-icon
                              icon="exclamation-triangle"
                              class="risk-0"
                      />
                      {{ $t('system.not_performed')}}
                    </span>
                  </span>
                  <span v-else>
                      <font-awesome-icon
                              icon="exclamation-triangle"
                              class="risk-0"
                      />
                      {{ $t('system.not_mitigated')}}
                    </span>
                </td>
              </tr>
              <tr v-if="vulnerabilitiesItems && !vulnerabilitiesItems.length" qid="no-results-row" class="text-center">
                <td colspan="10">
                  <h5 class="mt-3">
                    {{ $t('system.no_results') }}
                  </h5>
                </td>
              </tr>
              <tr v-if="vulnerabilitiesShowMore">
                <td colspan="10">
                  <div class="text-center">
                    <span class="cursor-pointer" @click="loadVulnerabilities()">{{ $t('system.show_more') }}</span>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        </div>
      </b-tab>
    </b-tabs>

  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';
  import {config} from '@/config.js'

  export default {
    name: 'MitigatingFactors',
    data: function() {
      return {
        error: '',
        loadingItems: false,
        selectedDS: [],
        selectedDSSort: '',
        selectedDSDirection: '',
        acValidationShow: false,
        acTableItems: [],
        acLoading: true,
        threatsItems: [],
        threatsPage: 1,
        threatsShowMore: true,
        vulnerabilitiesItems: [],
        vulnerabilitiesPage: 1,
        vulnerabilitiesShowMore: true,
        genericControlsItems: [],
        genericControlsPage: 1,
        genericControlsShowMore: true,
        updateValidationList: false,
        itemToDelete: {},
        itemObject: {},
        reCertificationOptions: [],
        provisioningOptions: [],
        selectedRC: [],
        selectedP: [],
        showDSDescription: false,
        buttonDisabled: false,
        descriptionLength: 200,
        showBusinessDescription: false,
        showPrivacyDescription: false,
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      },
      activity: {
        type: Object,
        required: true
      },
      riskScenarioItem: {
        type: Object,
        required: true
      }
    },
    components: {
      Avatar
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getBusinessAmount() {
        let transformed = ''
        if (this.riskScenarioItem && this.riskScenarioItem.business_amount) {
          transformed = this.riskScenarioItem.business_amount.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1.")
        }
        return transformed
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
        this.loadVulnerabilities(true);
        this.loadGenericControls(true);
        this.loadThreats(true);
      },
    },
    methods: {
      hasType(type) {
        let self = this;
        let found = false
        if (this.riskScenarioItem && this.riskScenarioItem.risk_scenario) {
          if (this.riskScenarioItem.risk_scenario.risk_types && this.riskScenarioItem.risk_scenario.risk_types.length) {
            _.find(this.riskScenarioItem.risk_scenario.risk_types, function(item) {
              if (item == type) {
                found = true;
              }
            });
          }
        }
        return found
      },
      loadThreats(reset) {
        if (reset) {
          this.threatsItems = [];
          this.threatsPage = 1;
          this.threatsShowMore = true;
        }
        let self = this;
        piincHttp.get('risk-scenarios/' + this.riskScenarioItem.risk_scenario.slug + '/threats', { params:
          {
            client: this.getClient.slug,
            per_page: 3,
            page: this.threatsPage,
            with_last_performed: 1,
            model_type: self.activity.who_am_i,
            model_id: self.activity.id
          }
        }).then(function(response) {
          if (response.data.items && (response.data.items.length < 3 || (response.data.items.length == 3 && response.data.total_count == 3 * self.threatsPage))) {
            self.threatsShowMore = false;
          }
          self.threatsPage = self.threatsPage + 1;
          self.threatsItems.push(...response.data.items);
        }, function() {});
      },
      loadVulnerabilities(reset) {
        if (reset) {
          this.vulnerabilitiesItems = [];
          this.vulnerabilitiesPage = 1;
          this.vulnerabilitiesShowMore = true;
        }
        let self = this;
        piincHttp.get('risk-scenarios/' + this.riskScenarioItem.risk_scenario.slug + '/vulnerabilities', { params:
          {
            client: this.getClient.slug,
            per_page: 3,
            page: this.vulnerabilitiesPage,
            with_last_performed: 1,
            model_type: self.activity.who_am_i,
            model_id: self.activity.id
          }
        }).then(function(response) {
          if (response.data.items && (response.data.items.length < 3 || (response.data.items.length == 3 && response.data.total_count == 3 * self.vulnerabilitiesPage))) {
            self.vulnerabilitiesShowMore = false;
          }
          self.vulnerabilitiesPage = self.vulnerabilitiesPage + 1;
          self.vulnerabilitiesItems.push(...response.data.items);
        }, function() {});
      },
      loadGenericControls(reset) {
        if (reset) {
          this.genericControlsItems = [];
          this.genericControlsPage = 1;
          this.genericControlsShowMore = true;
        }
        let self = this;
        piincHttp.get('risk-scenarios/' + this.riskScenarioItem.risk_scenario.slug + '/generic-controls', { params:
          {
            client: this.getClient.slug,
            per_page: 3,
            page: this.genericControlsPage,
            model_type: this.activity.who_am_i,
            model_id: this.activity.id
          }
        }).then(function(response) {
          if (response.data.items && (response.data.items.length < 3 || (response.data.items.length == 3 && response.data.total_count == 3 * self.genericControlsPage))) {
            self.genericControlsShowMore = false;
          }
          self.genericControlsPage = self.genericControlsPage + 1;
          self.genericControlsItems.push(...response.data.items);
        }, function() {});
      },
    },
    created () {
      // Table items
      this.loadVulnerabilities();
      this.loadGenericControls();
      this.loadThreats();
    }
  }
</script>
